import { useLocation, useNavigate } from "react-router-dom";
import "./ForgotPassword.css";
import { Button, TextField } from "@mui/material";
import NumberInput from "./ui/NumberInput";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "./Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
const ForgotPassword = () => {
  const location = useLocation();
  const isParent = location.state?.parent || false;
  const userData = {
    firstName: "",
    lasttName: "",
    phoneNumber: "",
    newPassword: "",
    confirmNewPassword: "",
  };
  const [formData, setFormData] = useState(userData);
  const [loading, setLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const navigate = useNavigate();

  function handleOnChange(e) {
    const { name, value } = e.target;
    if (name === "phoneNumber") {
      const phoneNumberConversion = Number(value);
      if (isNaN(phoneNumberConversion)) {
        return toast.warn("Please enter only numbers");
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
  async function handleSubmit(e) {
    e.preventDefault();
    const baseURL = process.env.REACT_APP_BACKEND_URL;
    const url = isParent
      ? baseURL + "/api/parentForgotPassword"
      : baseURL + "/api/pediatricianForgotPassword";
    const validateAllFields = Object.values(formData).every((value) => !!value);
    if (!validateAllFields) {
      return toast.warn("All fields are required");
    }
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,16}$/;
    if (!passwordRegex.test(formData.newPassword)) {
      toast.warn(
        "Password must be 8-16 characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character."
      );
      return;
    }
    if (formData.confirmNewPassword !== formData.newPassword) {
      return toast.warn("New password and Confirm new password do not match");
    }
    try {
      setLoading(true);
      const payload = {
        firstName: formData?.firstName.trim(),
        lasttName: formData?.lasttName.trim(),
        phoneNumber: formData?.phoneNumber.trim(),
        newPassword: formData?.newPassword.trim(),
        confirmNewPassword: formData?.confirmNewPassword.trim(),
      };
      const response = await axios.post(url, payload, {
        withCredentials: true,
      });
      if (response?.data?.success) {
        setLoading(false);
        toast.success("Password changed successfully");
        console.log(response.data);
        navigate(isParent ? "/parent-login" : "/pediatrician-login");
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      if (!error.response) {
        toast.error("Network error. Please check your internet connection.");
      } else {
        const message =
          error.response.data?.message ||
          "Something went wrong, please try again";
        toast.error(message);
      }
    }
  }
  return (
    <div className="forgot-password-container">
      <Loader isLoading={loading} />
      <div className="forgot-password-innerContainer">
        <div
          className="forgot-password-back-container"
          onClick={() => navigate(-1)}
        >
          <button className="update-backButton">
            <FontAwesomeIcon className="icon" icon={faArrowLeft} />
          </button>

          <p className="back-text">Back to Login</p>
        </div>
        <h2>
          {isParent
            ? "Reset Password for Parent"
            : "Reset Password for Provider"}
        </h2>

        <form
          noValidate
          onSubmit={handleSubmit}
          className="forgot-password-form"
        >
          <TextField
            size="small"
            type="text"
            name="firstName"
            label="First Name"
            required
            sx={{ width: "240px" }}
            onChange={handleOnChange}
          />

          <TextField
            size="small"
            type="text"
            name="lasttName"
            label="Last Name"
            required
            sx={{ width: "240px" }}
            onChange={handleOnChange}
          />

          <NumberInput
            name={"phoneNumber"}
            label={"PhoneNumber"}
            required
            sx={{ width: "240px" }}
            onChange={handleOnChange}
          />
          <div style={{ position: "relative" }}>
            <TextField
              size="small"
              type={!isPasswordVisible ? "password" : "text"}
              name="newPassword"
              label="New Password"
              required
              sx={{ width: "240px" }}
              onChange={handleOnChange}
            />
            <FontAwesomeIcon
              icon={isPasswordVisible ? faEyeSlash : faEye}
              onClick={() => setIsPasswordVisible((prev) => !prev)}
              style={{
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#555",
              }}
            />
          </div>
          <div style={{ position: "relative" }}>
            <TextField
              size="small"
              type={!isConfirmPasswordVisible ? "password" : "text"}
              name="confirmNewPassword"
              label="Confirm NewPassword"
              required
              sx={{ width: "240px" }}
              onChange={handleOnChange}
            />
            <FontAwesomeIcon
              icon={isConfirmPasswordVisible ? faEyeSlash : faEye}
              onClick={() => setIsConfirmPasswordVisible((prev) => !prev)}
              style={{
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#555",
              }}
            />
          </div>

          <Button type="submit" variant="contained" sx={{ width: "100px" }}>
            Reset
          </Button>
        </form>
      </div>
    </div>
  );
};
export default ForgotPassword;
